<template>
    <v-dialog
        v-model="showDialog"
    >
        <v-data-table
            :headers="headers"
            :items="items"
            :loading="loading.fetch ? 'teal' : null"
        >
            <template #top>
                <v-card-title style="background-color: #009688; color: white;">
                    {{ data.DIAG_T }}
                    <v-spacer />
                    <v-btn
                        color="success"
                        @click="handleInsertMemberToScopedBenefit"
                    >
                        <v-icon>{{ mdiPlus }}</v-icon>add
                    </v-btn>
                    &nbsp;
                    <v-btn
                        color="error"
                        @click="showDialog = false"
                    >
                        <v-icon>{{ mdiClose }}</v-icon>close
                    </v-btn>
                </v-card-title>
            </template>
            <template #[`item.ADDED_ON`]="{ item }">
                {{ formatDateToPst(item.ADDED_ON) }}
            </template>
            <template #[`item.BIRT_D`]="{ item }">
                {{ formatDateToPst(item.BIRT_D) }}
            </template>
            <template #[`item.SEX`]="{ item }">
                <v-chip :color="item.SEX === 'M' ? 'blue lighten-1' : 'pink lighten-1'">
                    <v-icon color="white">
                        {{ item.SEX === 'M' ? mdiGenderMale : mdiGenderFemale }}
                    </v-icon>
                    {{ item.SEX === 'M' ? 'Male' : 'Female' }}
                </v-chip>
            </template>
            <template #[`item.ACTIONS`]="{ item }">
                <v-tooltip top>
                    <template #activator="{ on }">
                        <v-btn
                            icon
                            color="error"
                            v-on="on"
                            @click="handleShowRemoveMember(item)"
                        >
                            <v-icon>{{ mdiTrashCan }}</v-icon>
                        </v-btn>
                    </template>
                    <span>Remove Member</span>
                </v-tooltip>
            </template>
        </v-data-table>
        <AddMember
            :show="display.add"
            :data="display.data"
            :notif="notif"
            :loading="loading"
            :members="items"
            @closeDialog="display.add = false"
        />
        <RemoveMember
            :show="display.remove"
            :data="display.data"
            :notif="notif"
            @closeDialog="display.remove = false"
            @handleLoadingFetchMembersOfScopedBenefit="loading.fetch = true"
        />
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AddMember from './AddMember.vue'
import { moment } from '../../../../../../utils/date-shim'
import RemoveMember from './RemoveMember.vue'
import {
    mdiPlus,
    mdiClose,
    mdiGenderMale,
    mdiGenderFemale,
    mdiTrashCan
} from '@mdi/js'

export default {
    components: { AddMember, RemoveMember },
    props: ['show', 'data', 'notif'],
    data: ()=>({
        mdiPlus,
        mdiClose,
        mdiGenderMale,
        mdiGenderFemale,
        mdiTrashCan,
        loading: {
            fetch: false
        },
        display: {
            add: false,
            data: null,
            remove: false
        },
        items: [],
        headers: [
            // { text: 'BENEFIT_ID', value: 'BENEFIT_ID' },
            // { text: 'ACCT_N', value: 'ACCT_N' },
            { text: 'Member Number', value: 'MEMB_N' },
            { text: 'Member Name', value: 'LAST_M' },
            { text: 'Sex', value: 'SEX' },
            { text: 'Birthdate', value: 'BIRT_D' },
            { text: 'Age', value: 'AGE' },
            { text: 'Added On', value: 'ADDED_ON' },
            { text: 'Added By', value: 'ADDED_BY' },
            { text: 'Actions', value: 'ACTIONS' }
        ]
    }),
    computed: {
        ...mapGetters(['fetchMembersOfScopedBenefitData']),
        showDialog: {
            get() {
                if (this.show) this.initData()
                return this.show
            },
            set() {
                this.$emit('closeDialog')
            }
        }
    },
    watch: {
        fetchMembersOfScopedBenefitData(newVal) {
            if (newVal) {
                if (newVal.status === 200) {
                    this.items = newVal.data
                }
            } else {
                this.items = []
            }
            this.loading.fetch = false
        }
    },
    methods: {
        ...mapActions(['fetchMembersOfScopedBenefit']),
        handleShowRemoveMember(data) {
            this.display.remove = true
            this.display.data = data
        },
        formatDateToPst(date) {
            if (date) {
                return moment(date).utcOffset('+0800').format('MMMM DD, YYYY')
            } else {
                return '-'
            }
        },
        handleInsertMemberToScopedBenefit() {
            this.display.add = true
            this.display.data = { BENEFIT_ID: this.data.ID, ACCT_N: this.data.ACCT_N }
        },
        initData() {
            this.loading.fetch = true
            const params = { BENEFIT_ID: this.data.ID, ACCT_N: this.data.ACCT_N }
            this.fetchMembersOfScopedBenefit(params)
        }
    }


}
</script>
